import { IconGiftOff, IconShieldCheckFilled } from '@tabler/icons-react';
import React from 'react';

import InsuranceShield from 'assets/icons/InsuranceShield';
import { BRAND_COLORS } from 'brand-guidelines/colors';

import { Text, Wrapper } from './styled-components';

const getInsuranceBadgeOptions = (inNetwork: boolean) => {
  if (inNetwork) {
    return {
      label: 'In-Network',
      color: BRAND_COLORS.lightGreen,
      icon: <IconShieldCheckFilled size={14} />,
    };
  }

  return {
    label: 'Out-of-Network',
    color: BRAND_COLORS.red,
    icon: <InsuranceShield inNetwork={false} size={14} />,
  };
};

interface StatusBadgeProps {
  color: string;
  icon: React.ReactNode;
  label: string;
  isSensitive?: boolean;
}

const StatusBadge = ({ color, icon, label, isSensitive }: StatusBadgeProps) => {
  const className = isSensitive ? 'sensitive-data' : '';
  return (
    <Wrapper className={className} $color={color}>
      {icon}
      <Text color={color}>{label}</Text>
    </Wrapper>
  );
};

interface InsuranceStatusBadgeProps {
  inNetwork: boolean;
}

export const InsuranceStatusBadge = ({ inNetwork }: InsuranceStatusBadgeProps) => {
  if (typeof inNetwork !== 'boolean') {
    return null;
  }

  const { color, icon, label } = getInsuranceBadgeOptions(inNetwork);

  return (
    <StatusBadge
      color={color}
      icon={icon}
      label={label}
      isSensitive
    />
  );
};

export const NoOffersStatusBadge = () => {
  return (
    <StatusBadge
      color="#A04335"
      icon={<IconGiftOff size={14} />}
      label="No Reward"
    />
  );
};
